import React from 'react'

// Custom marks for the four hero figures, in FIGURES order. Drawn for a 24px
// box at 1.75px stroke so they hold up in a 44px badge; all currentColor so the
// badge decides the colour. Octicons were tried first and read as generic.
const base = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
}

// ~1B posts: a masonry feed — two columns of cards at staggered heights.
export const FeedIcon = () => (
  <svg {...base}>
    <rect x="3" y="3" width="8" height="10" rx="1.5" />
    <rect x="3" y="15.5" width="8" height="5.5" rx="1.5" />
    <rect x="13" y="3" width="8" height="5.5" rx="1.5" />
    <rect x="13" y="11" width="8" height="10" rx="1.5" />
  </svg>
)

// 20M+ accounts: a cluster of overlapping profile bubbles.
export const AccountsIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="9" r="5.5" />
    <path d="M6.2 11.6a2.4 2.4 0 0 1 3.6 0" />
    <circle cx="8" cy="7.4" r="1.4" />
    <circle cx="16.5" cy="8" r="4.5" style={{ fill: 'var(--badge-bg, transparent)' }} />
    <path d="M15 10.1a2 2 0 0 1 3 0" />
    <circle cx="16.5" cy="6.7" r="1.15" />
    <circle cx="12.5" cy="16.5" r="4.5" style={{ fill: 'var(--badge-bg, transparent)' }} />
    <path d="M11 18.6a2 2 0 0 1 3 0" />
    <circle cx="12.5" cy="15.2" r="1.15" />
  </svg>
)

// 250K+ tracked daily: streams flowing in from the left into a collector.
export const InflowIcon = () => (
  <svg {...base}>
    <path d="M3 6c4 0 5 5 9 6" />
    <path d="M3 12h9" />
    <path d="M3 18c4 0 5-5 9-6" />
    <circle cx="3" cy="6" r="1" fill="currentColor" stroke="none" />
    <circle cx="3" cy="12" r="1" fill="currentColor" stroke="none" />
    <circle cx="3" cy="18" r="1" fill="currentColor" stroke="none" />
    <rect x="14" y="7" width="7" height="10" rx="2" />
    <path d="M16.5 10.5h2M16.5 13.5h2" />
  </svg>
)

// 300M+ in 12 months: a pile of points building into a rising graph.
export const BuildupIcon = () => (
  <svg {...base}>
    <circle cx="4" cy="19" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="7" cy="19" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="5.5" cy="16.2" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="10" cy="19" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="8.5" cy="16.2" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="7" cy="13.4" r="1.1" fill="currentColor" stroke="none" />
    <path d="M10.5 15.5 14 11.5l3 2.5L21 8" />
    <path d="M17.5 8H21v3.5" />
    <path d="M3 21.5h18" />
  </svg>
)

export const FIGURE_ICONS = [FeedIcon, AccountsIcon, InflowIcon, BuildupIcon]
